import { ReadOnlyStepProps } from "../../useStepEditor";
import { useAutomationStep } from "../../../../automations/hooks/useAutomationStep";
import { Block } from "../../../../../components/atoms";
import { ReadOnlyMessage } from "../../../components/ReadOnlyMessage";
import { isEmpty } from "lodash";
import { LegacyEmailViewer } from "./../LegacyEmailViewer";
import { EmailMembers } from "./../EmailMembers";
import { AttachmentViewer } from "modules/workflows/blocks/Attachments/AttachmentViewer";
import { TaskAssignmentViewer } from "../../../components/TaskAssignmentViewer";
import { StepReminderViewer } from "../../../components/StepReminderViewer";

export const EmailTaskV2StepViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step) return <div />;

  const { resolved } = step.resolvedData as any;

  if (!resolved) return <LegacyEmailViewer step={step} />;

  const executionData = step.executionData as any;
  const taskAssignments = executionData?.taskAssignments || [];

  const stepData = step.stepData as any;
  const reminderConfig = stepData?.reminders?.[0];

  return (
    <>
      {!isEmpty(taskAssignments) && (
        <Block blended compact>
          <TaskAssignmentViewer taskAssignments={taskAssignments} />
        </Block>
      )}
      <Block blended compact>
        <EmailMembers {...resolved} />
      </Block>
      {reminderConfig && (
        <Block blended compact>
          <StepReminderViewer stepId={stepId} reminderConfig={reminderConfig} />
        </Block>
      )}
      <Block blended compact>
        <ReadOnlyMessage
          subject={resolved.subject}
          message={resolved.displayMessage ?? resolved.message}
          opens={stepData?.trackEmail ? executionData?.opens : undefined}
        />
      </Block>
      {!isEmpty(resolved.attachments) && (
        <Block blended compact>
          <AttachmentViewer attachments={resolved.attachments} />
        </Block>
      )}
    </>
  );
};
